import { useRequest } from 'hooks/useRequest';
import Loader from 'pages/Loader';
import React, { useState } from 'react'
import { AiOutlineSearch } from 'react-icons/ai'
//import { BsSearch } from 'react-icons/bs';
import { GrClose } from 'react-icons/gr'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setFilterProducts } from 'redux/product/productSlice';
//import { setSearchlist } from 'redux/search/searchSlice';
import auth from 'utils/Auth';
import { useTranslation } from 'react-i18next'
import {dataLayerPush} from 'utils/Datalayer';

const NavbarSearch = () => {
  const [inputFocus, setInputFocus] = useState(false)
  //const [search, setSearch] = useState('')
  const [timer, setTimer] = useState(null)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [request,loading] = useRequest()
  const [searchLength, setSearchLength] = useState('')
  const { t } = useTranslation()
  const { userInfo } = useSelector(state => state.general)

  //var allResults = JSON.parse(localStorage.getItem("search"))?.slice(0).slice(-6);

  const {productFilterList} = useSelector(state => state.product);


  // useEffect(() => {
  //   const delayDebounceFn = setTimeout(() => {
  //     if (search.length > 2) {
  //       setTimeout(() => {
  //         request('/Catalog/Products', {
  //           method: 'GET',
  //           params: {
  //             Search: search
  //           }
  //         }).then(res => {
  //           if (res?.data?.ok) {
  //             dispatch(setProducts(res?.data?.result))
  //             dispatch(setSearchlist(search))

  //             navigate("/search");

  //             //Son  5 aramayı localStorage'a kaydeder..
  //             const items = JSON.parse(localStorage.getItem("search"))?.length < 5 ?
  //               JSON.parse(localStorage.getItem("search"))
  //               : JSON.parse(localStorage.getItem("search"))?.slice(1).slice(-5);
  //             const newItems = items ? JSON.stringify([...items, search]) : "[]"
  //             localStorage.setItem("search", newItems);
  //           }
  //         }, 2000)

  //       })
  //     } else {
  //       dispatch(setProducts())
  //       dispatch(setSearchlist(""))
  //     }
  //   }, 1400)

  //   return () => clearTimeout(delayDebounceFn)
  // }, [search])

  const headerOptions = {
    RestaurantId : auth?.getUserChoises()?.restaurantId,
    DeliveryType : auth?.getUserChoises()?.deliveryType,
    NeighbourhoodId : auth?.getUserChoises()?.neighbourhoodId,
    RegionId : auth?.getUserChoises()?.regionId,
  }


  const onSearch = (e) => {
    let val = e.target.value; 
    setSearchLength(val)
    //let backspace = e.key == "Backspace"
    clearTimeout(timer)

    const newTimer = setTimeout(() => {
        request('/Catalog/Products', {
          method: 'GET',
          headers: headerOptions,
          params: {
            Search: searchLength
          }
        })
   .then((res) => {
    if(res){
      dataLayerPush({
        event:"search",
        search_term:searchLength,
        component:"search box",
        user_id:userInfo?.userId
      })
      dispatch(setFilterProducts(res?.data?.result?.items))
    }
   })
    }, 1000)

    setTimer(newTimer)
  }

  var allResults = JSON.parse(localStorage.getItem("historySearch"))?.slice(0).slice(-6);

  const navigateResult = (product) => {

    const items = JSON.parse(localStorage.getItem("historySearch"))?.length < 5 ?
      JSON.parse(localStorage.getItem("historySearch"))
      : JSON.parse(localStorage.getItem("historySearch"))?.slice(1).slice(-5);
      const newItems = items ? JSON.stringify([...items, product]) : "[]"
      localStorage.setItem("historySearch", newItems);

      navigate(`/urun/${product?.url}`)
  }


   const renderSearchFunc = () => {
     if(searchLength.length > 0 && inputFocus){
        return (
          <div tabIndex={0} className='allResultsContainer'>
          <div onMouseDown={() => setSearchLength('')} className='allResultsContainer-close'>
            <GrClose size={16} />
          </div>
          <div className='allResultsContainer-searchContainer'>
          <Loader isDataLoading={loading} />

            {productFilterList?.map((product, i) => (
              <div onMouseDown={() => navigateResult(product)} className='allResultsContainer-sub' key={i}>
                <div>
                    <img src={product?.productImages?.[0]} alt="" />
                </div>
                <div className=''>
                      <div className='allResultsContainer-sub-title'>{product?.name}</div>
                      <div className='allResultsContainer-sub-subtitle'>{product?.shortDescription}</div>
                </div>
              </div>
            ))}
          </div>
         

        </div>
        )
     }else if(searchLength.length == 0 && inputFocus){
       return (
        <div tabIndex={0} className='allResultsContainer'>
          <div className='allResultsContainer-searchContainer'>
            {allResults?.map((product, i) => (
              <div onMouseDown={() => onMouseDown(product)} className='allResultsContainer-sub' key={i}>
                <div>
                    <AiOutlineSearch size={30}/>
                </div>
                <div className=''>
                      <div className='allResultsContainer-sub-title'>{product?.name}</div>
                      <div className='allResultsContainer-sub-subtitle'>{product?.shortDescription}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
       )
     }
   }

   const onBlurFunc = () => {
    setSearchLength('')
    setInputFocus(false)
   }
   const onMouseDown = (product) => {
    setSearchLength('')
    navigate(`/urun/${product?.url}`)
   }

  return (
    <div style={inputFocus ? {padding: "4px 16px 4px 16px"}: {}}  className={`navbar-search ${!auth.isHaveToken() ? 'search-sm' : ''} ${inputFocus ? 'expandSearchInput' : 'noneExpand'}`}>
     <><AiOutlineSearch onClick={() => setInputFocus(!inputFocus)} size={22} color='#B40000' />
      <input
        autoComplete='off'
        type="text"
        placeholder={t('searchFoodPlaceholder')}
        value={searchLength}
        name="search"
        onChange={onSearch}
        onFocus={() => setInputFocus(true)}
        onBlur={onBlurFunc}
        //onClick={() => setInputFocus(!inputFocus)}
        tabIndex={1}
      /></>

      {renderSearchFunc()}
    </div>
  )
}

export default NavbarSearch